<template>
  <div class="container-fluid mt-5">
    <div class="d-flex flex-column flex-sm-row justify-content-sm-between mb-3">
      <div>
        <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
          Branch List
        </div>
      </div>
      <div class="mt-sm-0 mt-3">
        <el-input
          class="w-100 rounded-border"
          :prefix-icon="Search"
          placeholder="Search"
          v-model="searchText"
        />
      </div>
    </div>
    <div class="row" v-loading="branchLoading">
      <div class="col-md-12 mt-2 px-0">
        <div
          v-for="(branches, parentGroup) in filteredGroups"
          :key="parentGroup"
          class="mb-4"
          style="height: 581px; overflow-y: scroll"
        >
          <div
            class="bg-gray-500 text-dak border-radius-8 px-3 py-2 font-weight-bold"
          >
            {{ parentGroup }}
          </div>
          <CustomTable
            :data="branches"
            :headers="branchHeaders"
            :checkMultipleItem="false"
          >
            <template v-slot:name="{ item }">
              <div class="c-pointer fw-500" @click="viewBranch(item)">
                <div>{{ item.name }}</div>
              </div>
            </template>
            <template v-slot:membershipSize="{ item }">
              <div class="c-pointer" @click="viewBranch(item)">
                {{ item.membershipSize.toLocaleString() }}
              </div>
            </template>
            <template v-slot:currentYearAverageAttendance="{ item }">
              <div class="c-pointer" @click="viewBranch(item)">
                {{
                  Math.abs(item.currentYearAverageAttendance).toLocaleString()
                }}
              </div>
            </template>
            <template v-slot:currentYearIncome="{ item }">
              <div class="c-pointer" @click="viewBranch(item)">
                {{
                  item.currency && item.currency.shortCode
                    ? item.currency.shortCode
                    : ""
                }}
                {{ Math.abs(item.currentYearIncome).toLocaleString() }}
              </div>
            </template>
            <template v-slot:currentYearExpense="{ item }">
              <div class="c-pointer" @click="viewBranch(item)">
                {{
                  item.currency && item.currency.shortCode
                    ? item.currency.shortCode
                    : ""
                }}
                {{ Math.abs(item.currentYearExpense).toLocaleString() }}
              </div>
            </template>
          </CustomTable>
        </div>
      </div>
    </div>
    <div
      class="no-person"
      v-if="!branchLoading && !networkError && allBranchDetail.length === 0"
    >
      <div class="empty-img">
        <p><img src="../../assets/people/people-empty.svg" alt="" /></p>
        <p class="tip">You haven't added any Branch yet</p>
        <el-button
          round
          class="header-btn"
          @click="showModal"
          :color="primarycolor"
        >
          Add Branch
        </el-button>
      </div>
    </div>
    <div v-else-if="networkError && !branchLoading" class="adjust-network">
      <img src="../../assets/network-disconnected.png" />
      <div>
        {{
          navigatorLang === "en-US"
            ? "Opps, Your internet connection was disrupted"
            : $t("people.internetConnectionDisrupted")
        }}
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, inject, onMounted, watch, computed, watchEffect } from "vue";
import CustomTable from "@/components/table/CustomTable";
import axios from "@/gateway/backendapi";
import { Search } from "@element-plus/icons-vue";

const searchText = ref("");
const branchLoading = ref(false);
const groupedBranches = ref({});
const groupedBranche = ref({});
const primarycolor = inject("primarycolor");
const networkError = ref(false);
const allBranchDetail = ref([]);
const branchHeaders = ref([
  { name: "", value: "name" },
  { name: "MEMBERS", value: "membershipSize" },
  { name: "AVG.ATTENDANCE.", value: "currentYearAverageAttendance" },
  { name: "INCOME", value: "currentYearIncome" },
  { name: "EXPENSE", value: "currentYearExpense" },
  // { name: "ACTION", value: "action" },
]);

const getBranchess = async () => {
  branchLoading.value = true;
  try {
    const { data } = await axios.get(
      "/api/Branching/GetBranchesBasicInformation"
    );
    const branches = data.returnObject.branches;
    const brancheses = data.returnObject.branches;
    allBranchDetail.value = data.returnObject;
    const grouped = {};
    for (const branch of branches) {
      const groupKey = branch.parentNames || "Ungrouped";

      if (!grouped[groupKey]) {
        grouped[groupKey] = [];
      }

      grouped[groupKey].push(branch);
    }
    branchLoading.value = false;

    groupedBranches.value = grouped;

    const groupes = {};
    for (const brach of brancheses) {
      const groupKy = brach.name || "Ungrouped";

      if (!groupes[groupKy]) {
        groupes[groupKy] = [];
      }

      groupes[groupKy].push(brach);
    }
    branchLoading.value = false;

    groupedBranche.value = groupes;
  } catch (error) {
    branchLoading.value = false;
    console.log("Failed to fetch branches:", error);
  }
};
getBranchess();
const filteredGroups = computed(() => {
  if (!searchText.value.trim()) {
    return groupedBranches.value;
  }

  const lowerSearch = searchText.value.toLowerCase();

  const result = {};

  for (const [groupName, branches] of Object.entries(groupedBranches.value)) {
    const filtered = branches.filter((branch) =>
      branch.name.toLowerCase().includes(lowerSearch)
    );
    if (filtered.length > 0) {
      result[groupName] = filtered;
    }
  }

  return result;
});
</script>
<style scoped>
.empty-img {
  width: 85%;
  margin: auto;
}

.empty-img img {
  width: 100%;
  max-width: 200px;
}
.no-person {
  height: 80vh;
  display: flex;
  text-align: center;
}
</style>
